import { render, staticRenderFns } from "./move-file.vue?vue&type=template&id=c595b120&scoped=true"
import script from "./move-file.vue?vue&type=script&lang=js"
export * from "./move-file.vue?vue&type=script&lang=js"
import style0 from "./move-file.vue?vue&type=style&index=0&id=c595b120&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c595b120",
  null
  
)

export default component.exports